import React from 'react';
import Icon from '@icons';

const FormCheckbox = (field) => {
    const isInteractionBlocked = field.isLocked || field.isDisabled;
        return (
        <div
            className="formGroup mrNone"
            style={isInteractionBlocked ? { opacity: 0.5, cursor: 'not-allowed', pointerEvents: 'none' } : {}}
        >
            <input
                {...field.input}
                name={field.input.name}
                id={field.input.name}
                type="checkbox"
                className="custom-checkbox"
                disabled={isInteractionBlocked}
                checked={field.isLocked ? true : field.input.value}
                onChange={(e) => {
                    if (isInteractionBlocked) return;
                    field.input.onChange(e.target.checked);
                    if (field.onFieldValueChange) {
                        field.onFieldValueChange(e.target.checked, field.input.name);
                    }
                }}
            />
            <label htmlFor={field.input.name}>
                {field.label}
                {field.isRequired && <sup>*</sup>}
                {field.helpText && (
                    <span className="quickTooltip-bottom" data-quicktooltip={field.helpText}>
                        <Icon name="info" className="icon ml greyInfoIcon" />
                    </span>
                )}
            </label>
            {field.meta.touched && field.meta.error && (
                <span className="error-text">{field.meta.error}</span>
            )}
        </div>
    );
};

export default FormCheckbox;